<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xs"
    persistent
    scrollable
    :max-width="`${width}px`"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon flat @click="$emit('cancel')">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-toolbar-title>{{ titleDialog }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu bottom left>
          <v-btn slot="activator" dark icon>
            <v-icon>library_add</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click="materiInputDialog = true">
              <v-list-tile-avatar>
                <v-icon>chrome_reader_mode</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title> Materi </v-list-tile-title>
              <materi-input
                :dialog="materiInputDialog"
                title="MATERI"
                action="ADD"
                primary_key="id_materi"
                primary_field="materi"
                @cancel="materiInputDialog = false"
                @submitted="materiInputDialog = false"
              >
              </materi-input>
            </v-list-tile>
            <v-list-tile
              v-if="profil.role == 'ADMIN'"
              @click="clientInputDialog = true"
            >
              <v-list-tile-avatar>
                <v-icon>business</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>Client</v-list-tile-title>
              <client-input
                :dialog="clientInputDialog"
                title="CLIENT"
                action="ADD"
                primary_key="id_client"
                primary_field="client"
                @cancel="clientInputDialog = false"
                @submitted="clientInputDialog = false"
              >
              </client-input>
            </v-list-tile>
            <v-list-tile @click="trainerInputDialog = true">
              <v-list-tile-avatar>
                <v-icon>directions_run</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>Trainer</v-list-tile-title>
              <trainer-input
                :dialog="trainerInputDialog"
                title="TRAINER"
                action="ADD"
                primary_key="id_trainer"
                primary_field="trainer"
                @cancel="trainerInputDialog = false"
                @submitted="trainerInputDialog = false"
              >
              </trainer-input>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-btn icon :dark="!sameInput" :disabled="sameInput" @click="submit">
          <v-icon>save</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text style="height: 1000px">
        <v-form>
          <v-container grid-list-md class="pa-0">
            <v-layout wrap>
              <v-flex xs12 sm5>
                <v-card-title class="subheading font-weight-bold pl-0 pb-0"
                  >RINCIAN TRAINING</v-card-title
                >
                <v-divider class="mb-4"></v-divider>
                <v-select
                  v-if="dialog"
                  autofocus
                  append-icon="local_offer"
                  attach
                  item-text="laman"
                  item-value="id_laman"
                  :items="lamanByLaman"
                  v-model="input.id_laman"
                  v-validate="'required'"
                  name="id_laman"
                  data-vv-name="id_laman"
                  label="Business Unit"
                  data-vv-as="Business Unit"
                  :error-messages="errors.collect('id_laman')"
                >
                  <template slot="item" slot-scope="data">
                    <v-list-tile-content>
                      <v-list-tile-title>{{
                        data.item.laman
                      }}</v-list-tile-title>
                      <v-list-tile-sub-title>{{
                        data.item.laman_desc
                      }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </v-select>
                <v-autocomplete
                  append-icon="chrome_reader_mode"
                  attach
                  :disabled="!input.id_laman"
                  item-text="materi"
                  item-value="id_materi"
                  :items="materiByLaman"
                  v-model="input.id_materi"
                  v-validate="'required'"
                  name="id_materi"
                  data-vv-name="id_materi"
                  label="Materi"
                  data-vv-as="Materi"
                  :error-messages="errors.collect('id_materi')"
                >
                </v-autocomplete>
                <v-container grid-list-md class="pa-0">
                  <v-layout wrap>
                    <v-flex sm12 md6>
                      <v-select
                        append-icon="style"
                        attach
                        item-text="pel_tipe"
                        item-value="id_pel_tipe"
                        :items="pel_tipe"
                        v-model="input.id_pel_tipe"
                        v-validate="'required'"
                        name="id_pel_tipe"
                        data-vv-name="id_pel_tipe"
                        label="Tipe"
                        data-vv-as="Tipe"
                        :error-messages="errors.collect('id_pel_tipe')"
                      >
                      </v-select>
                    </v-flex>
                    <v-flex sm12 md6>
                      <v-select
                        append-icon="streetview"
                        attach
                        item-text="pel_tempat"
                        item-value="id_pel_tempat"
                        :items="pel_tempat"
                        v-model="input.id_pel_tempat"
                        v-validate="'required'"
                        name="id_pel_tempat"
                        data-vv-name="id_pel_tempat"
                        label="Tempat"
                        data-vv-as="Tempat"
                        :error-messages="errors.collect('id_pel_tempat')"
                      >
                      </v-select>
                    </v-flex>
                    <v-flex sm12 md6>
                      <v-datetime-picker
                        appendIcon="timer"
                        locale="id-id"
                        label="Waktu Mulai"
                        :max="$moment().format('YYYY-MM-DD')"
                        v-model="input.waktu_mulai"
                      >
                      </v-datetime-picker>
                    </v-flex>
                    <v-flex sm12 md6>
                      <v-datetime-picker
                        appendIcon="timer_off"
                        label="Waktu Selesai"
                        locale="id-id"
                        :max="$moment().format('YYYY-MM-DD')"
                        v-model="input.waktu_selesai"
                      >
                      </v-datetime-picker>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-textarea
                  auto-grow
                  :rows="1"
                  counter
                  append-icon="note"
                  type="text"
                  v-model="input.keterangan"
                  v-validate="'required'"
                  name="keterangan"
                  data-vv-name="keterangan"
                  label="Keterangan"
                  data-vv-as="Keterangan"
                  :error-messages="errors.collect('keterangan')"
                >
                </v-textarea>
                <div
                  v-for="(pel_file_tipe, index) in pel_file_tipes"
                  :key="`pel_file_tipes-${index}`"
                >
                  <v-card-title class="subheading pl-0 pb-0">
                    <b>DOKUMEN {{ pel_file_tipe }}</b
                    >&nbsp;
                    <small>(format PDF)</small>
                  </v-card-title>
                  <v-divider class="mb-2"></v-divider>
                  <upload-button
                    accept="application/pdf"
                    :prefill="input.files | filterFiles(pel_file_tipe)"
                    :download="input.files | downloaderFiles(pel_file_tipe)"
                    @error="onError"
                    @remove="removeFile(pel_file_tipe)"
                    @change="changeFile($event, pel_file_tipe)"
                  >
                  </upload-button>
                </div>
              </v-flex>
              <v-flex xs12 sm7>
                <v-card-title class="subheading font-weight-bold pl-0 pb-0"
                  >CLIENT YANG MENGIKUTI</v-card-title
                >
                <v-divider class="mb-2"></v-divider>
                <v-container
                  v-for="(client, i) in input.clients"
                  :key="`clients-${i}`"
                  grid-list-sm
                  class="pa-0"
                >
                  <v-layout wrap>
                    <v-flex xs12 sm8 md9>
                      <v-autocomplete
                        item-text="client"
                        item-value="id_client"
                        attach
                        :items="clientByLaman"
                        v-model="client.id_client"
                        v-validate="'required'"
                        :name="`id_client[${i}]`"
                        :data-vv-name="`id_client[${i}]`"
                        :label="`Nama Client ${i + 1}`"
                        :data-vv-as="`Nama Client ${i + 1}`"
                        :error-messages="errors.collect(`id_client[${i}]`)"
                      >
                        <template slot="selection" slot-scope="data">
                          {{ `${data.item.client} (${data.item.area})` }}
                        </template>
                        <template slot="item" slot-scope="data">
                          <v-list-tile-content
                            :class="{
                              'red--text': !parseInt(data.item.active_client)
                            }"
                          >
                            <v-list-tile-title>{{
                              data.item.client
                            }}</v-list-tile-title>
                            <v-list-tile-sub-title>{{
                              data.item.area
                            }}</v-list-tile-sub-title>
                          </v-list-tile-content>
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm4 md3>
                      <v-text-field
                        :append-outer-icon="
                          i == 0 ? 'add_circle' : 'remove_circle'
                        "
                        @click:append-outer="
                          () => (i == 0 ? addClient() : removeClient(i))
                        "
                        type="number"
                        min="0"
                        v-model="client.peserta_hadir"
                        v-validate="'numeric|required'"
                        :name="`peserta_hadir[${i}]`"
                        :data-vv-name="`peserta_hadir[${i}]`"
                        :label="`Peserta ${i + 1}`"
                        :data-vv-as="`Peserta ${i + 1}`"
                        :error-messages="errors.collect(`peserta_hadir[${i}]`)"
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-card-title class="subheading font-weight-bold pl-0 pb-0"
                  >TRAINER YANG MENGHANDLE</v-card-title
                >
                <v-divider class="mb-2"></v-divider>
                <v-autocomplete
                  append-icon="directions_run"
                  attach
                  multiple
                  chips
                  item-value="id_trainer"
                  item-text="trainer"
                  :items="trainer"
                  v-model="input.id_trainers"
                  v-validate="'required'"
                  name="id_trainers"
                  data-vv-name="id_trainers"
                  label="Trainer"
                  data-vv-as="Trainer"
                  :error-messages="errors.collect('id_trainers')"
                >
                  <template slot="selection" slot-scope="data">
                    <v-chip
                      :selected="data.selected"
                      close
                      @input="data.parent.selectItem(data.item)"
                    >
                      {{ `${data.item.trainer} (${data.item.trainer_divisi})` }}
                    </v-chip>
                  </template>
                  <template slot="item" slot-scope="data">
                    <v-list-tile-content>
                      <v-list-tile-title>{{
                        data.item.trainer
                      }}</v-list-tile-title>
                      <v-list-tile-sub-title>{{
                        data.item.trainer_divisi
                      }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </v-autocomplete>
                <div
                  v-for="(pel_photo_tipe, key) in pel_photo_tipes"
                  :key="`pel_photo_tipes-${key}`"
                >
                  <v-card-title class="subheading pl-0 pb-0">
                    <b>PHOTO {{ pel_photo_tipe }}</b
                    >&nbsp;
                    <small>(minimal 1)</small>
                  </v-card-title>
                  <v-divider class="mb-2"></v-divider>
                  <v-container grid-list-sm class="pa-0">
                    <v-layout
                      wrap
                      class="grey"
                      :class="[$vuetify.dark ? 'darken-5' : 'lighten-5']"
                    >
                      <v-flex
                        v-for="(photo, index) in pel_photos[pel_photo_tipe]"
                        v-if="index < 2 || pel_photo_tipe == 'ABSENSI'"
                        :key="`pel_photos-${index}`"
                        xs12
                        sm6
                        md4
                        style="position: relative"
                      >
                        <picture-input
                          :ref="`pictureInput_${pel_photo_tipe}_${index}`"
                          :zIndex="1"
                          :alertOnError="false"
                          :prefill="photo.pel_photo | checkImage"
                          :customStrings="c.VUE_PICTURE_INPUT"
                          :hideChangeButton="true"
                          :width="$vuetify.breakpoint.xs ? 120 : 150"
                          :height="$vuetify.breakpoint.xs ? 120 : 150"
                          accept="image/jpeg,image/jpg,image/png"
                          :size="10"
                          @change="changePhoto(pel_photo_tipe, index)"
                          @error="onError"
                        >
                        </picture-input>
                        <v-btn
                          fab
                          small
                          color="red"
                          class="mt-4"
                          top
                          right
                          absolute
                          @click="removePhoto(photo.index)"
                        >
                          <v-icon color="white">close</v-icon>
                        </v-btn>
                      </v-flex>
                      <v-flex
                        v-if="
                          pel_photos[pel_photo_tipe].length < 2 ||
                          pel_photo_tipe == 'ABSENSI'
                        "
                        sm6
                        md4
                      >
                        <picture-input
                          :ref="`pictureInput_${pel_photo_tipe}`"
                          :zIndex="1"
                          :alertOnError="false"
                          :customStrings="c.VUE_PICTURE_INPUT"
                          :hideChangeButton="true"
                          :width="$vuetify.breakpoint.xs ? 120 : 150"
                          :height="$vuetify.breakpoint.xs ? 120 : 150"
                          accept="image/jpeg,image/jpg,image/png"
                          :size="10"
                          @change="changePhoto(pel_photo_tipe)"
                          @error="onError"
                        >
                        </picture-input>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>
import _ from "lodash";
import c from "@/constants";
import PictureInput from "@/components/widgets/input/PictureInput";
import UploadButton from "@/components/widgets/input/UploadButton";
import VDatetimePicker from "@/components/widgets/input/DatetimePicker";
import MateriInput from "@/components/pages/input/MateriInput";
import TrainerInput from "@/components/pages/input/TrainerInput";
import ClientInput from "@/components/pages/input/ClientInput";
import { mapState, mapGetters } from "vuex";

const defaultInput = {
  keterangan: "",
  id_pel_tipe: "",
  id_pel_tempat: "",
  id_materi: "",
  id_laman: "",
  waktu_mulai: "",
  waktu_selesai: "",
  clients: [{ id_client: "", peserta_hadir: "" }],
  id_trainers: [],
  photos: [],
  files: [],
  id_user: ""
};

export default {
  name: "training-input",
  components: {
    PictureInput,
    UploadButton,
    VDatetimePicker,
    MateriInput,
    TrainerInput,
    ClientInput
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: null
    },
    action: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    primary_key: {
      type: String,
      default: ""
    },
    primary_field: {
      type: String,
      default: ""
    },
    width: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      input: _.cloneDeep(defaultInput),
      dataInjected: null,
      c: c,
      pel_file_tipes: ["POSTEST", "PRETEST"],
      pel_photo_tipes: ["KEGIATAN", "BERKUMPUL", "ABSENSI"],
      pel_photos: { KEGIATAN: [], BERKUMPUL: [], ABSENSI: {} },
      // other dialog
      materiInputDialog: false,
      trainerInputDialog: false,
      clientInputDialog: false
    };
  },
  computed: {
    ...mapState(["status", "id_laman$"]),
    ...mapState("auth", ["profil"]),
    ...mapState("trainer", ["trainer"]),
    ...mapState("training", ["pel_tipe", "pel_tempat"]),
    ...mapGetters("laman", ["lamanByLaman"]),
    ...mapGetters("client", ["clientByLaman"]),
    ...mapGetters("materi", ["materiByLaman"]),
    source() {
      return this.$store.state[this.primary_field][this.primary_field];
    },
    titleDialog() {
      let title = this.action == "ADD" ? "TAMBAH" : "EDIT";
      return `${title} ${this.title}`;
    },
    sameInput() {
      return _.isEqual(this.input, this.dataInjected);
    }
  },
  methods: {
    submit() {
      this.$validator.validateAll().then(noError => {
        if (noError) {
          this.$store
            .dispatch(
              `${this.primary_field}/${this.action}_${this.title}`,
              this.input
            )
            .then(() => {
              let new_id =
                this.action == "ADD"
                  ? _.last(this.source)[this.primary_key]
                  : null;
              this.$emit("submitted", new_id);
            })
            .catch();
        } else {
          this.$store.commit(
            "ERROR",
            "Ada field yang masih error, cek kembali isian form!"
          );
        }
      });
    },
    separatePhotos: function() {
      for (let i = 0; i < this.input.photos.length; i++) {
        this.input.photos[i].index = i;
      }
      for (let i = 0; i < this.pel_photo_tipes.length; i++) {
        this.pel_photos[this.pel_photo_tipes[i]] = this.input.photos.filter(
          p => p.pel_photo_tipe == this.pel_photo_tipes[i]
        );
      }
    },
    changePhoto(pel_photo_tipe, index) {
      let refs =
        typeof index === "undefined"
          ? this.$refs[`pictureInput_${pel_photo_tipe}`][0]
          : this.$refs[`pictureInput_${pel_photo_tipe}_${index}`][0];
      if (refs.file) {
        let photo = {
          pel_photo: refs.file,
          pel_photo_tipe: pel_photo_tipe
        };
        if (typeof index === "undefined") {
          this.input.photos.push(photo);
          refs.removeImage();
        } else {
          this.input.photos.splice(index, 1, photo);
        }
        this.separatePhotos();
      } else {
        this.$store.commit(
          "ERROR",
          "FileReader API tidak didukung, gunakan browser terbaru."
        );
      }
    },
    removePhoto(index) {
      this.input.photos.splice(index, 1);
      this.separatePhotos();
    },
    addClient() {
      this.input.clients.push({ id_client: "", peserta_hadir: "" });
    },
    removeClient(i) {
      this.input.clients.splice(i, 1);
    },
    changeFile(file, pel_file_tipe) {
      this.removeFile(pel_file_tipe);
      this.input.files.push({ pel_file: file, pel_file_tipe: pel_file_tipe });
    },
    removeFile(pel_file_tipe) {
      _.remove(this.input.files, ["pel_file_tipe", pel_file_tipe]);
      this.input.files = [...this.input.files];
    },
    onError(e) {
      this.$store.commit("ERROR", e.message);
    }
  },
  filters: {
    checkImage: function(image) {
      if (image) {
        return typeof image === "object" ? image : c.PHOTO_TRAINING_URL + image;
      }
      return "";
    },
    filterFiles: function(files, pel_file_tipe) {
      let file = files.filter(f => f.pel_file_tipe == pel_file_tipe)[0];
      if (file) return file.pel_file;
      return "";
    },
    downloaderFiles: function(files, pel_file_tipe) {
      let file = files.filter(f => f.pel_file_tipe == pel_file_tipe)[0];
      if (file) {
        if (file.id_pel_file) return c.FILE_TES_URL + file.pel_file;
      }
      return "";
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        this.$validator.reset();
        if (this.action == "ADD") {
          this.dataInjected = _.cloneDeep(defaultInput);
          this.dataInjected.id_user = this.profil.id_user;
          this.dataInjected.id_laman = this.id_laman$;
        } else {
          this.dataInjected = _.cloneDeep(this.data);
        }
        // IF EMPTY DATETIME
        if (!this.dataInjected.waktu_mulai)
          this.dataInjected.waktu_mulai = this.$moment().format(
            "YYYY-MM-DD HH:mm:ss"
          );
        if (!this.dataInjected.waktu_selesai)
          this.dataInjected.waktu_selesai = this.$moment().format(
            "YYYY-MM-DD HH:mm:ss"
          );
        this.input = _.cloneDeep(this.dataInjected);
        // SEPARATE PHOTOS
        this.separatePhotos();
      }
    }
  },
  mounted() {
    this.$store.dispatch("training/GET_TRAINING");
    this.$store.dispatch("training/GET_OPTIONS");
    this.$store.dispatch("user/GET_USER");
  }
};
</script>
